import { render, staticRenderFns } from "./RoundedCard.vue?vue&type=template&id=74c742d3&scoped=true&"
import script from "./RoundedCard.vue?vue&type=script&lang=js&"
export * from "./RoundedCard.vue?vue&type=script&lang=js&"
import style0 from "./RoundedCard.vue?vue&type=style&index=0&id=74c742d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c742d3",
  null
  
)

export default component.exports